import styled from 'styled-components';

import { getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';

export const CoverageMapContainer = styled.div`
    position: relative;
    min-height: 650px;
    height: 80vh;
`;

export const CoverageMapIframe = styled.iframe`
    width: 100%;
    height: 100%;
    border: 0;
`;

type VisibleProps = {
    $isVisible: boolean;
};

export const CoverageMapIframeLoader = styled.div<VisibleProps>`
    background: ${getPurpurColor('transparentWhite800')};
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    display: ${(props) => (props.$isVisible ? 'flex' : 'none')};
`;
